module.exports = __webpack_public_path__ + "static/login-brain-475cc23c4ec81eaa2ec55eb04e1fa8d2.png";